export const Eyebrow = ({ children, onNavy = false, className = "" }) => (
    <div
        className={`text-[13px] font-semibold uppercase tracking-[0.14em] ${
            onNavy ? "text-gold" : "text-gold-text"
        } ${className}`}
    >
        {children}
    </div>
);

export const SectionTitle = ({ children, as: Tag = "h2", className = "" }) => (
    <Tag
        className={`m-0 font-bold text-[26px] md:text-[32px] lg:text-[36px] leading-[1.15] tracking-[-0.02em] text-navy ${className}`}
    >
        {children}
    </Tag>
);
